import React from "react";
import AdminLayout from "@/components/AdminLayout";
import CmsResource from "@/components/CmsResource";

const fields = [
  { name: "name", label: "Nome", type: "text" },
  { name: "slug", label: "Slug", type: "text" },
  { name: "order", label: "Ordem", type: "number" },
  { name: "short_intro", label: "Introdução curta", type: "textarea", wide: true, rows: 2 },
  { name: "full_description", label: "Descrição completa", type: "textarea", wide: true, rows: 6 },
  { name: "highlights", label: "Destaques", type: "list", wide: true },
  { name: "buyer_profile", label: "Perfil de comprador", type: "textarea", wide: true, rows: 3 },
  { name: "market_notes", label: "Notas de mercado", type: "textarea", wide: true, rows: 3 },
  { name: "avg_price_sqm", label: "Preço médio €/m² (apartamentos)", type: "number", help: "Ex: 3080. Fonte Idealista/Confidencial Imobiliário — actualizar trimestralmente." },
  { name: "avg_price_sqm_source", label: "Fonte do €/m²", type: "text", placeholder: "Idealista" },
  { name: "avg_price_sqm_updated", label: "Actualizado em", type: "text", placeholder: "Fev 2026" },
  { name: "price_by_typology", label: "Preço €/m² por tipologia", type: "list-object", wide: true, help: "Actualizar quando revisar o preço médio da zona.", subfields: [
    { name: "typology", label: "Tipologia", placeholder: "T2" },
    { name: "price_sqm", label: "€/m²", type: "number", placeholder: "3140" },
  ]},
  { name: "main_image", label: "Imagem principal", type: "image", wide: true },
  { name: "gallery", label: "Galeria", type: "image-list", wide: true },
  { name: "faqs", label: "FAQs da zona", type: "list-object", wide: true, subfields: [
    { name: "question", label: "Pergunta" },
    { name: "answer", label: "Resposta" },
  ]},
  { name: "cta_label", label: "CTA — texto", type: "text" },
  { name: "cta_url", label: "CTA — link", type: "text" },
];

const defaults = {
  name: "", slug: "", order: 0, short_intro: "", full_description: "", highlights: [],
  buyer_profile: "", market_notes: "", main_image: "", gallery: [], faqs: [],
  cta_label: "Falar com a Zélia", cta_url: "/contacto",
  avg_price_sqm: null, avg_price_sqm_source: "", avg_price_sqm_updated: "",
  price_by_typology: [],
};

export default function AdminZones() {
  return (
    <AdminLayout>
      <CmsResource
        resource="zones"
        title="Zonas"
        singular="Zona"
        fields={fields}
        defaults={defaults}
        displayColumns={[
          { key: "name", label: "Nome" },
          { key: "slug", label: "Slug" },
          { key: "order", label: "Ordem" },
        ]}
      />
    </AdminLayout>
  );
}
